import React, { useState } from 'react';
import { useQuery } from 'react-query';
import RouteringService, { Routering, RouteringStatus } from './routering-service';
import Page from '../page/Page';
import { getTranslation, getTranslationHtml } from '../locales/i18n';
import { ActionSpinner } from '../components/actionspinner/action-spinner';
import { RouteringCard } from './routering.card';
import { getDigidSysteemNaam } from './digidsysteem.model';

const RouteringPageEdit: React.FC<any> = () => {
  const [routeringen, setRouteringen] = useState<Routering[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [statuses, setStatuses] = useState<{ [key: string]: string }>({});

  const { isLoading } = useQuery<Routering[], Error>(
    'query-routeringen',
    async () => {
      return await RouteringService.findForUser();
    },
    {
      onSuccess: (res) => {
        setError(null);
        setRouteringen(res);
        const initialStatuses = res.reduce(
          (acc, r) => {
            acc[r.uuid] = r.status;
            return acc;
          },
          {} as { [key: string]: string },
        );
        setStatuses(initialStatuses);
      },
      onError: (err: any) => setError(JSON.stringify(err.response?.data || err, null, 2)),
    },
  );

  const handleStatusChange = async (uuid: string, newStatus: string) => {
    if (newStatus === RouteringStatus.ACTIEF) {
      await RouteringService.activateRouting(uuid);
    } else if (newStatus === RouteringStatus.INACTIEF) {
      await RouteringService.deactivateRouting(uuid);
    }
    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      [uuid]: newStatus,
    }));
  };

  return (
    <Page title={getTranslation(routeringen.length > 0 ? 'routering.title.eigen' : 'routering.noData.title')}>
      {isLoading && <ActionSpinner />}
      {!isLoading && error && <div className="error">{getTranslation('routering.fetching.error')}</div>}
      {!isLoading && routeringen.length === 0 && <div data-cy={'no-data-text'}>{getTranslationHtml('routering.noData.eigen')}</div>}
      {routeringen.length > 0 && (
        <div className="vl-alert" role="alertdialog">
          <div className="vl-alert__content">
            <div className="vl-alert__message">
              <p>{getTranslation('routering.uitleg')}</p>
              <ul className="vl-icon-list" style={{ listStyle: 'none' }}>
                <li className="vl-icon-list__item">
                  <i className="vl-vi vl-vi-warning" aria-hidden="true"></i>
                  {getTranslation('routering.disclaimer')}
                </li>
                <li className="vl-icon-list__item">
                  <i className="vl-vi vl-vi-warning" aria-hidden="true"></i>
                  {getTranslationHtml('routering.gdpr')}
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
      {routeringen.length > 0 &&
        routeringen.map((r) => {
          const digidNaam = getDigidSysteemNaam(r.digidSysteem);
          return (
            <RouteringCard digidNaam={digidNaam} status={statuses[r.uuid]} periodeVan={r.periodeVan} periodeTot={r.periodeTot} key={r.uuid}>
              {Object.values(RouteringStatus).map((s) => (
                <label className="vl-radio vl-radio--block" htmlFor={s + r.uuid} key={s + r.uuid} data-cy={'routering-' + digidNaam + '-' + s}>
                  <input
                    className="vl-radio__toggle"
                    type="radio"
                    id={s + r.uuid}
                    name={'routering-' + r.uuid}
                    data-cy={'routering-' + digidNaam + '-' + s + '-input'}
                    value={s}
                    checked={statuses[r.uuid] === s}
                    onChange={(e) => handleStatusChange(r.uuid, e.target.value)}
                  />
                  <div className="vl-radio__label ">{getTranslation('routering.section.' + s.toLowerCase(), { digidName: digidNaam })}</div>
                </label>
              ))}
            </RouteringCard>
          );
        })}
    </Page>
  );
};

export default RouteringPageEdit;
